import * as components from "./index";
import React from "react";
import {
  Product,
  RuntimeConfig,
  ConfigProps,
  FeatureFlags,
} from "../types/types";
import { Experiences } from "@/getServerSideProps/monetate/getExperiences/experiencesSchema";
import { VariantCreditOffering } from "@/types/cobeTypes";

export type StandardProps = {
  product: Product;
  runtimeConfig: RuntimeConfig;
  flags: FeatureFlags;
  experiencesRawObject: Experiences;
  configProps?: ConfigProps;
  creditOffersV2: VariantCreditOffering[];
};

type StandardComponent = (
  props: StandardProps & {
    sizes: string;
  },
) => React.ReactNode;

type ComponentMap = { [name: string]: StandardComponent };

export const componentMap: ComponentMap = components;
